<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-content">
        <div class="footer-section">
          <div class="footer-logo">
            <div class="logo">
              <!-- <img src="../assets/白色logo-轻助.png" alt="轻助信息科技" class="logo-image" /> -->
              <h3>轻助信息科技</h3>
            </div>
            <div class="social-links">
              <a href="#" class="social-link">📘</a>
              <a href="#" class="social-link">🐦</a>
              <a href="#" class="social-link">💼</a>
              <a href="#" class="social-link">📷</a>
              <a href="#" class="social-link">📺</a>
            </div>
          </div>
        </div>
        
        <div class="footer-section">
          <h4>关于我们</h4>
          <ul class="footer-links">
            <li><a href="#home">首页</a></li>
            <!-- <li><a href="#">团队介绍</a></li>
            <li><a href="#">发展历程</a></li> -->
            <li><a href="#concat">联系我们</a></li>
          </ul>
        </div>
        
        <div class="footer-section">
          <h4>服务</h4>
          <ul class="footer-links">
            <li><a href="#">产品设计</a></li>
            <li><a href="#">技术开发</a></li>
            <li><a href="#">系统集成</a></li>
            <li><a href="#">运维支持</a></li>
          </ul>
        </div>
        
        <!-- <div class="footer-section">
          <h4>订阅我们的新闻</h4>
          <div class="newsletter">
            <input type="email" placeholder="输入您的邮箱" class="newsletter-input">
            <button class="newsletter-btn">订阅</button>
          </div>
        </div> -->
      </div>
      
      <div class="footer-bottom">
        <div class="footer-bottom-content">
          <p>&copy; 2025 轻助信息科技 ｜ <span class="icp-info">蒙ICP备2025030888号-1</span> ｜ 保留所有权利。</p>
          
          <div class="footer-bottom-links">
            <!-- <a href="#">隐私政策</a>
            <a href="#">服务条款</a>
            <a href="#">Cookie政策</a> -->
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>

<style scoped>
.footer {
  background: #1f2937;
  color: white;
  padding: 60px 0 0;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.footer-content {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  gap: 48px;
  margin-bottom: 48px;
}

.footer-section h4 {
  font-size: 1.125rem;
  font-weight: 600;
  margin-bottom: 24px;
  color: #f9fafb;
}

.logo {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.logo-image {
  width: 120px;
  height: 120px;
  object-fit: contain;
  border-radius: 6px;
}

.footer-logo h3 {
  font-size: 1.5rem;
  font-weight: 700;
  color: white;
  margin: 0;
}

.footer-logo p {
  color: #9ca3af;
  margin: 0 0 24px 0;
  line-height: 1.6;
}

.social-links {
  display: flex;
  gap: 16px;
}

.social-link {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: #374151;
  border-radius: 8px;
  color: #9ca3af;
  transition: all 0.3s ease;
}

.social-link:hover {
  background: #2563eb;
  color: white;
  transform: translateY(-2px);
}

.footer-links {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-links li {
  margin-bottom: 12px;
}

.footer-links a {
  color: #9ca3af;
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-links a:hover {
  color: #09D6F9;
}

.footer-bottom {
  border-top: 1px solid #374151;
  padding: 24px 0;
}

.footer-bottom-content {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
}

.footer-bottom p {
  color: #9ca3af;
  margin: 0;
}

.icp-info {
  color: #9ca3af;
  font-size: 0.875rem;
  margin: 0;
  display: inline;
}

.footer-bottom-links {
  display: flex;
  gap: 24px;
}

.footer-bottom-links a {
  color: #9ca3af;
  text-decoration: none;
  font-size: 0.875rem;
  transition: color 0.3s ease;
}

.footer-bottom-links a:hover {
  color: #09D6F9;
}

.newsletter {
  display: flex;
  gap: 8px;
  margin-top: 16px;
}

.newsletter-input {
  flex: 1;
  padding: 12px 16px;
  border: 1px solid #374151;
  border-radius: 8px;
  background: #374151;
  color: white;
  font-size: 0.875rem;
}

.newsletter-input::placeholder {
  color: #9ca3af;
}

.newsletter-input:focus {
  outline: none;
  border-color: #3C59FF;
}

.newsletter-btn {
  padding: 12px 20px;
  background: linear-gradient(135deg, #3C59FF, #09D6F9);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.newsletter-btn:hover {
  background: linear-gradient(135deg, #2A2B32, #00EDB2);
  transform: translateY(-1px);
}

@media (max-width: 768px) {
  .footer {
    padding: 40px 0 0;
  }
  
  .container {
    padding: 0 16px;
  }
  
  .footer-content {
    grid-template-columns: 1fr;
    gap: 32px;
  }
  
  .footer-section h4 {
    font-size: 1.125rem;
    margin-bottom: 16px;
  }
  
  .footer-links {
    gap: 12px;
  }
  
  .footer-links a {
    font-size: 0.875rem;
  }
  
  .newsletter {
    flex-direction: column;
    gap: 12px;
  }
  
  .newsletter-input {
    width: 100%;
  }
  
  .newsletter-btn {
    width: 100%;
  }
  
  .footer-bottom {
    padding: 24px 0;
  }
  
  .footer-bottom-content {
    flex-direction: column;
    text-align: center;
    gap: 12px;
  }
  
  .footer-bottom p {
    font-size: 0.875rem;
    line-height: 1.5;
  }
  
  .icp-info {
    font-size: 0.8rem;
  }
  
  .footer-bottom-links {
    justify-content: center;
    flex-wrap: wrap;
  }
}
</style>
